<div class="activity-stream-list-container">
  <div
    #scrollContainer
    class="items">
    @for (item of items; track item?.id) {
      <coin-c-activity-stream-item
        [item]="item"
        (showDetailsClicked)="toggleItemDetails(item)"></coin-c-activity-stream-item>
    }
  </div>
</div>
